import { actionTypeConstants } from "../utils";

function signatureReducer(state = {}, action = {} as any) {

  switch (action.type) {
    case 'STORE_SIGNATURES_API':
      return {
        ...state,
        list: action.payload || []
      };
    //TODO : make the sign and aggree state generic so that it should work for any page instead of adding for each page 
    case actionTypeConstants.EXTRA_ORDINARY_ACCEPT_SIGN:
      return {
        ...state,
        extraOrdinary: {
          agreeCheck: action.payload.status,
        }
      }
    case actionTypeConstants.MOVE_DETAILS_ACCEPT_SIGN:
      return {
        ...state,
        moveDetails: {
          agreeCheck: action.payload.status,
        }
      }
    case actionTypeConstants.TERMS_AND_CONDITIONS_ACCEPT_SIGN:
      return {
        ...state,
        termsAndConditions: {
          agreeCheck: action.payload.status,
        }
      }
    case actionTypeConstants.PICKUP_AUTH_ACCEPT_SIGN:
      return {
        ...state,
        pickUpAuth: {
          agreeCheck: action.payload.status,
        }
      }
    default:
      return state;
  }
}

export default signatureReducer;
